import React from "react";

const Header = () => {
  return (
    <div className="loader-container">
      <span className="loader"></span>
      <span className="loader-rev"></span>
    </div>
  );
};

export default Header;
